import { environment } from './environment';

export function isLegacyLoginEnabled(): boolean {
  if (environment.useLegacyLogin) {
    return true;
  }

  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  const host = String(window.location.hostname || '').toLowerCase();

  return host.indexOf('beekeeper-esas-test') !== -1 || host === 'localhost' || host === '127.0.0.1';
}
